// The records the chain is about (a contact, its company, its deals — R-M6), inside the letter's single page as a block of related
// records, as on a record's page (um/2026-10-30/03 п.8): the type's icon, the title and the section; a row opens the record.

import type { Id } from '@confdeck/core-shared';
import { recordTitle } from '@confdeck/core-shared';
import { RelatedBlock } from '../../record/single.tsx';
import { useMeta, useSync, useTypesTick } from '../../sync/react.tsx';

export function Linked({ ids }: { ids: Id[] }) {
  const client = useSync();
  const meta = useMeta();
  const recs = ids.map((id) => client.store.record(id)).filter((r) => !!r && !r.archivedAt);
  useTypesTick([...new Set(recs.map((r) => r!.typeId))]);
  if (!recs.length) return null;
  return <RelatedBlock title="Связи" items={recs.map((r) => {
    const t = meta.type(r!.typeId);
    return { key: r!.id, icon: t?.icon ?? 'square', title: recordTitle(r!, meta), sub: t?.name, href: `/r/${r!.id}` };
  })} />;
}
